// src/components/ScrollToTop/ScrollToTop.jsx
import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    if (window.gaEvent) {
      window.gaEvent("scroll_ylos_klikattu");
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-28 right-6 z-50">
      <AnimatePresence>
        {isVisible && (
          <motion.button
            initial={{ opacity: 0, y: 40, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 40, scale: 0.8 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
            onClick={scrollToTop}
            aria-label="Siirry sivun yläosaan"
            className="
              flex items-center gap-2 px-4 py-2 rounded-full
              bg-joyridePurple dark:bg-joyrideCyan
              text-joyrideLight dark:text-joyrideNavy
              shadow-[0_8px_30px_rgba(0,0,0,0.5)]
              hover:shadow-[0_12px_40px_rgba(0,0,0,0.6)]
              hover:scale-105
              transition-all
            "
          >
            <FaArrowUp className="animate-bounce" />
            Alkuun
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ScrollToTop;
